<script>import { onMount } from "svelte";
import { fade } from "svelte/transition";
let showLoader = false;
let animateBar = false;
function beforeChange() {
  showLoader = true;
  animateBar = true;
}
function afterChange() {
  animateBar = false;
  setTimeout(() => {
    showLoader = false;
  }, 100);
}
onMount(() => {
  window.addEventListener("beforeRouteChange", beforeChange);
  window.addEventListener("afterRouteChange", afterChange);
  return () => {
    window.removeEventListener("beforeRouteChange", beforeChange);
    window.removeEventListener("afterRouteChange", afterChange);
  };
});
</script>

{#if showLoader}
	<div transition:fade={{ duration: 200 }} class="loader">
		<span class:start={animateBar} />
	</div>
{/if}

<style>.loader {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 4px;
  z-index: 9999999;
}
.loader span {
  display: block;
  background-color: var(--loader, yellow);
  height: 100%;
  width: 100%;
  translate: 0%;
}
.loader .start {
  animation: increment 3s ease forwards;
}

@keyframes increment {
  0% {
    translate: -100%;
  }
  100% {
    translate: -10%;
  }
}</style>
